import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 30px;
  width: 100%;
  padding: 0 50px;
  min-height: 60vh;

  @media all and (max-width: 980px) {
    padding: 0 16px;
  }

  .header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  .header h2 {
    margin-bottom: 0;
  }
  .header button {
    width: auto;
  }

  .users-account button,
  .users-account hr {
    display: none;
  }

  .createdDate {
    display: flex;
    flex-direction: column;
  }

  .approvedBadge,
  .reprovedBadge,
  .newProfileBadge,
  .deleteRequestBadge,
  .blockBadge {
    border-radius: 18px;
    padding: 5px 10px;
    color: #fff;
  }
  .approvedBadge {
    background: #00b050;
  }
  .reprovedBadge {
    background: #c63336;
  }
  .newProfileBadge {
    background: #ffcb29;
  }
  .deleteRequestBadge {
    background: #020c90;
  }
  .blockBadge {
    background: #d0a633;
  }

  // Styling MUI DataGrid //

  .dataGrid {
    text-align: center !important;
  }

  .MuiDataGrid-root {
    width: 100%;
    height: 100%;
  }

  .MuiDataGrid-columnHeader {
    background: #020c90;
    color: #fff;
    font-weight: bold;
    font-size: 16px;
    text-align: center !important;
    padding: 10px 0;
    border-bottom: 1px solid #ccc;

    .MuiSvgIcon-root {
      color: #fff;
      opacity: 1 !important;
    }
  }

  .MuiDataGrid-virtualScrollerRenderZone {
    text-align: center;
  }

  .css-1rtnrqa {
    display: none;
  }

  .css-68pk0f {
    width: 40%;

    @media all and (max-width: 768px) {
      width: 100%;
    }
  }

  .css-1knaqv7-MuiButtonBase-root-MuiButton-root {
    display: none;
  }

  .css-3be3ve-MuiFormControl-root-MuiTextField-root-MuiDataGrid-toolbarQuickFilter {
    width: 40%;

    @media all and (max-width: 768px) {
      width: 100%;
    }
  }

  .button-icon {
    background: none;
    border: none;
    cursor: pointer;
    margin: 0 5px;

    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
      &:hover {
        filter: none;
      }
    }

    img {
      width: 20px;

      &:hover {
        filter: brightness(0) saturate(100%) invert(16%) sepia(41%) saturate(7143%) hue-rotate(237deg) brightness(63%)
          contrast(126%);
      }
    }
  }

  ::-webkit-scrollbar {
    width: 25px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #9a9a9a;
    height: 5px;
    border-radius: 10px;
  }
`;

export const NavigationButtonsContainer = styled.section`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
  margin-bottom: 2rem;
  width: 100%;
  max-width: 100%;
  z-index: 1;

  @media (max-width: 768px) {
    margin-top: 10px;
    width: 100%;
    justify-content: flex-start;
    overflow-x: auto;
    flex-wrap: nowrap;

    &::-webkit-scrollbar {
      height: 0px;
    }
  }

  button {
    margin: 0;
    width: auto;

    @media (max-width: 768px) {
      font-size: 13px;
      flex-shrink: 0;
    }
  }
`;
